import { classes } from "../variables/classes"

export const init = () => {
  document.body.classList.add(classes.payrollForm)
}